import {
  SET_ADMIN_PROFILE,
  SET_ADMIN_PROFILE_ERROR,
  GET_ADMIN_PROFILE,
  GET_ADMIN_PROFILE_ERROR,
  EDIT_ADMIN_PASSWORD,
  EDIT_ADMIN_PASSWORD_ERROR,
  SET_CURRENT_PROFILE_IMG,
  SET_CURRENT_PROFILE_IMG_ERROR,
  SET_ERROR_MSG,
  SET_TABS,
  CHANGE_TABS,
  SET_CURRENT_PROFILE_IMG_SUCCESS,
  SET_IS_PROFILE_INFO_EDIT_SUCCESS,
  SET_IS_EDIT_SUCCESS,
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  SET_ADMIN_PROFILE_SUCCESS,
  EDIT_ADMIN_PASSWORD_SUCCESS,
  SET_PASSWORD_ERROR_MESSAGE,
} from '../../store/accountSettings/AccountSettingsConstants'

export const accountSettingsBlackList = [
  SET_ADMIN_PROFILE,
  SET_ADMIN_PROFILE_ERROR,
  GET_ADMIN_PROFILE,
  GET_ADMIN_PROFILE_ERROR,
  EDIT_ADMIN_PASSWORD,
  EDIT_ADMIN_PASSWORD_ERROR,
  SET_CURRENT_PROFILE_IMG,
  SET_CURRENT_PROFILE_IMG_ERROR,
  SET_ERROR_MSG,
  SET_TABS,
  CHANGE_TABS,
  SET_CURRENT_PROFILE_IMG_SUCCESS,
  SET_IS_PROFILE_INFO_EDIT_SUCCESS,
  SET_IS_EDIT_SUCCESS,
  EDIT_ADMIN_PASSWORD_SUCCESS,
  SET_PASSWORD_ERROR_MESSAGE,
]
